import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Counseling } from './pages/Counseling';
import { Articles } from './pages/Articles';
// Import placeholders for now, will build them next
import { Tests } from './pages/Tests';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Login } from './pages/Login';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="layanan" element={<Counseling data-id="element-7" />} data-id="element-6" />
          <Route path="artikel" element={<Articles data-id="element-9" />} data-id="element-8" />
          <Route path="tes" element={<Tests data-id="element-11" />} data-id="element-10" />
          <Route path="tentang" element={<About data-id="element-13" />} data-id="element-12" />
          <Route path="kontak" element={<Contact data-id="element-15" />} data-id="element-14" />
          <Route path="login" element={<Login data-id="element-17" />} data-id="element-16" />
        </Route>
      </Routes>
    </Router>;
}